/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages

        $(window).scroll(function() {
          if ($(document).scrollTop() > 50) {
            $(".top-logo").addClass("hider");
            $(".hidden-logo").addClass("show-logo");
            $(".menu-container").addClass("menu-shrink");
            $(".menu-bg").addClass("bg-shrink");
            $(".downarrow").addClass("downarrow-hider");
          } else {
            $(".top-logo").removeClass("hider");
            $(".hidden-logo").removeClass("show-logo");
            $(".menu-container").removeClass("menu-shrink");
            $(".menu-bg").removeClass("bg-shrink");
            $(".downarrow").removeClass("downarrow-hider");
          }
        });

        var touchStart = false;
        $(document).click(function(event) {
          if (!touchStart) {
            var target = $(event.target);
            // Close menu when clicking anything else than button or the menu items
            if (
              !target.closest("#nav-icon").length &&
              !target.closest(".navbar-nav").length
            ) {
              $(".navbar-nav, #nav-icon, body").removeClass("open");
            }
          }
        });

        // ScrollReveal.js
        window.sr = new ScrollReveal();
        // Custom Settings
        sr.reveal(".anim-1", {
          duration: 900,
          scale: 1,
          viewFactor: 0.25,
          distance: "2.5rem",
          easing: "cubic-bezier(.36, .71, .51, .97)"
        });
        sr.reveal(
          ".anim-2",
          {
            scale: 1,
            viewFactor: 0.25,
            easing: "cubic-bezier(.36, .71, .51, .97)",
            distance: "2.5rem",
            duration: 900
          },
          200
        );

        $(".instagram-slider").slick({
          autoplay: false,
          mobileFirst: true,
          arrows: true,
          draggable: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4
              }
            }
          ]
        });

        // Open/close menu
        $("#nav-icon").click(function(e) {
          var nav = $(".navbar-nav"),
            body = $("body");

          if (nav.hasClass("open")) {
            nav.removeClass("open");
            body.removeClass("menu-open");
          } else {
            nav.addClass("open");
            body.addClass("menu-open");
          }
        });

        $("#nav-icon").click(function() {
          $(this).toggleClass("open");
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

jQuery(".mea-switch").on("click", function(e) {
  jQuery(".mea-inner")
    .children("div")
    .toggleClass("show-mea");
});
